"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishedMarketingCardsNewMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class PublishedMarketingCardsNewMapper {
    toDomain(result) {
        const isLoading = lodash_1.default.get(result, "loading");
        const marketingCardsNew = lodash_1.default.get(result, "data.getPublishedMarketingCardsNew");
        return {
            isLoading,
            marketingCardsNew,
        };
    }
}
exports.PublishedMarketingCardsNewMapper = PublishedMarketingCardsNewMapper;
